import React, { Component } from "react";
// import {connect} from "react-redux";
// import {leavesActions, leavesSelectors} from "../../store/leaves";
import Layout from "../../components/Layout";
import Aiport from "../../pages/Airport";
import Loading from "../../components/Base/Loading";

class AiportContainer extends Component {
  state = {
    leaves: [],
    pending: [],
    approved: [],
    loading: true,
    currentTabIndex: -1,
  };

  componentDidMount() {
    const leave_type = localStorage.getItem("leaveType");
    this._getCurrentTabIndex(leave_type);
  }

  _getCurrentTabIndex = (leave_type) => {
    let currentTabIndex = 0;
    switch (leave_type) {
      case "Pending":
        currentTabIndex = 0;
        break;
      case "Leaving":
        currentTabIndex = 1;
        break;
      case "Returning":
        currentTabIndex = 2;
        break;
      case "Declined":
        currentTabIndex = 3;
        break;
      default:
        currentTabIndex = 0;
        break;
    }
    this.setState({ currentTabIndex });
  };

  render() {
    const { profile } = this.props;
    const { currentTabIndex } = this.state;

    return (
      <Layout {...this.props} withTabs>
        {profile === null || profile === undefined || currentTabIndex === -1 ? (
          <Loading />
        ) : (
          <Aiport {...this.props} {...this.state} />
        )}
      </Layout>
    );
  }
}

AiportContainer.propTypes = {};

// const mapStateToProps = (state) => ({
// 	loading: leavesSelectors.isLoading(state.leaves),
// 	leaves: leavesSelectors.refreshList(state.leaves),
//
// });
//
// const mapDispatchToProps = (dispatch) => ({
// 	updateList: (data) => dispatch(leavesActions.updateList(data)),
// })

export default AiportContainer;
